module.exports = __webpack_public_path__ + "static/media/money-withdraw.ea93b299.svg";